export default __webpack_public_path__ + "static/media/MusicalIntruments_11.466e61da.png";